import React from 'react';
import { Phone, Clock, Instagram, Facebook } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { restaurantInfo } from '@/data/menuData';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="fixed bottom-0 left-0 right-0 glass-dark border-t border-primary/20 z-40">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Contact Info */}
        <div className="flex items-center gap-3">
          {/* Phone */}
          <a
            href={`tel:${restaurantInfo.phone}`}
            className="flex items-center gap-2 text-foreground hover:text-primary transition-colors group"
          >
            <div className="w-9 h-9 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
              <Phone className="w-4 h-4 text-primary" />
            </div>
          </a>

          {/* Hours - visible on all screens */}
          <div className="flex items-center gap-1.5 text-muted-foreground text-xs border-l border-border/50 pl-3">
            <Clock className="w-3.5 h-3.5 text-primary/70" />
            <span className="font-body">
              {restaurantInfo.hours.open} - {restaurantInfo.hours.close}
            </span>
          </div>
        </div>

        {/* Social Media */}
        <div className="flex items-center gap-2">
          <a
            href={restaurantInfo.social.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 border border-purple-400/30 flex items-center justify-center text-foreground hover:from-purple-500/30 hover:to-pink-500/30 transition-all"
            aria-label="Instagram"
          >
            <Instagram className="w-4 h-4" />
          </a>
          <a
            href={restaurantInfo.social.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full bg-blue-500/20 border border-blue-400/30 flex items-center justify-center text-foreground hover:bg-blue-500/30 transition-all"
            aria-label="Facebook"
          >
            <Facebook className="w-4 h-4" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
